// extracted by mini-css-extract-plugin
export default {"scrollable-content":"ViewCurrencyDetails_scrollable-content__zNeQD","card":"ViewCurrencyDetails_card__WoNDB","ant-card-head-title":"ViewCurrencyDetails_ant-card-head-title__mJpVg"};